import * as React from "react";
import * as Sentry from "@sentry/react";
import { makeStyles } from "@fluentui/react-components";
import { QueryClientProvider } from "@tanstack/react-query";
import { WebAuthProvider } from "../context/WebAuthContext";
import { webEditorAdapter } from "../editor/webEditorAdapter";
import { queryClient, SubscriptionProvider, EditorProvider } from "@cuntas-mitool/ui";
import WebTool from "./WebTool";

const useStyles = makeStyles({
	root: {
		minHeight: "100vh",
	},
});

const WebApp = () => {
	const styles = useStyles();

	return (
		<Sentry.ErrorBoundary fallback={<div style={{ padding: 16 }}>Something went wrong. Please reload the page.</div>}>
			<div className={styles.root}>
				<EditorProvider adapter={webEditorAdapter}>
					<WebAuthProvider>
						<SubscriptionProvider>
							<QueryClientProvider client={queryClient}>
								<WebTool />
							</QueryClientProvider>
						</SubscriptionProvider>
					</WebAuthProvider>
				</EditorProvider>
			</div>
		</Sentry.ErrorBoundary>
	);
};

export default WebApp;
